export enum LOADER_VARIANTS {
    PRIMARY = 'primary',
    SUCCESS = 'success',
}

export enum LOADER_SIZES {
    SMALL = 'small',
    REGULAR = 'regular',
}
